var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"size":"small","columns":_vm.columns,"data-source":_vm.list,"pagination":_vm.pagination,"row-key":record => record.id,"loading":_vm.loading,"bordered":""},on:{"change":_vm.handleTableChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }